import {FAMILY_GROUP_SEARCH_PAYLOAD, SEARCH_PAYLOAD} from '../Types/types'


export function familyGroupSearchPayload(data: any) {
  return {
    type: FAMILY_GROUP_SEARCH_PAYLOAD,
    payload: data
  }
}
export function searchPayload(data: any) {
  return {
    type: SEARCH_PAYLOAD,
    payload: data
  }
}

export function emptySearchPayload()
{
  return {
    type: SEARCH_PAYLOAD,
    payload: null
  }
}